/**
 * Created by jimmy on 2022/6/5.
 */
import React, { useState, useEffect } from 'react';
import { Form, Select, Input, DatePicker, Button, Upload, message, Row, Col, AutoComplete, TreeSelect } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import './index.less';
// import * as LOCALE from "../../common/locale";

const CompModel = props => {
	const [form] = Form.useForm();
	const [importLoading, setImportLoading] = useState(false);

	const [fields, setFields] = useState([]);
	const initFields = () => {
		setFields(props.fields || []);
	};
	useEffect(() => {
		initFields();
		return () => false;
	}, [props.fields]);

	const doms = (() => {
		const doms = [];

		fields.map((item, idx) => {
			const _labelDom = <span style={{ paddingLeft: 0, display: 'block', boxSizing: 'border-box', overflow: 'hidden', whiteSpace: 'nowrap' }}>{item.label}</span>;
			// const _itemStyle = { marginBottom: 13, marginRight: 0, flex: '0 0 33.3333%', ...item.style };
			const _itemStyle = { ...item.style, marginRight: 20 };

			const colSpan = 8;

			const colKey = item.type + idx;
			switch (item.type) {
				case 'input':
					doms.push(
						<Col span={colSpan} key={colKey}>
							<Form.Item label={_labelDom} key={idx} name={item.name} style={{ ..._itemStyle }}>
								<Input placeholder={item.placeholder} allowClear />
							</Form.Item>
						</Col>
					);
					break;
				case 'select':
					doms.push(
						<Col span={colSpan} key={colKey}>
							<Form.Item label={_labelDom} key={idx} name={item.name} style={_itemStyle}>
								<Select {...{
									showSearch: true,
									optionFilterProp: 'children',
									filterOption: (input, option) => (option?.label ?? '').includes(input),
									allowClear: true,
									options: item.options,
									defaultValue: item.defaultValue || undefined,
									placeholder: item.placeholder,
								}} />
							</Form.Item>
						</Col>
					);
					break;
				case 'auto-complete':
					doms.push(
						<Col span={colSpan} key={colKey}>
							<Form.Item label={_labelDom} key={idx} name={item.name} style={_itemStyle}>
								<AutoComplete {...{
									options: item.options,
									placeholder: item.placeholder,
									filterOption: true,
									allowClear: true,
								}} />
							</Form.Item>
						</Col>
					);
					break;
				case 'date':
					doms.push(
						<Col span={colSpan} key={colKey}>
							<Form.Item label={_labelDom} key={idx} name={item.name} style={{ ..._itemStyle }}>
								<DatePicker format="YYYY-MM-DD" placeholder={item.placeholder} style={{ width: '100%' }} />
							</Form.Item>
						</Col>
					);
					break;
				case 'range-date':
					doms.push(
						<Col span={colSpan} key={colKey}>
							<Form.Item label={_labelDom} key={idx} name={item.name} style={{ ..._itemStyle }}>
								<DatePicker.RangePicker placeholder={item.placeholder || ['请输入起始时间', '请输入结束时间']} style={{ width: '100%' }} format="YYYY-MM-DD" />
							</Form.Item>
						</Col>
					);
					break;
				case 'tree-select':
					console.log('-----', item.option);
					doms.push(
						<Col span={colSpan} key={colKey}>
							<Form.Item label={_labelDom} key={idx} name={item.name} style={{ ..._itemStyle }}>
								<TreeSelect {...{
									allowClear: true,
									treeData: item.options,
									placeholder: '请选择分组',
									loadData: item.loadData
								}} />
							</Form.Item>
						</Col>
					);
					break;
				default:
					break;
			}
		});

		return doms;
	})();
	const btnDoms = (() => {
		const btnDoms = [];

		const _btnStyle = { marginLeft: 16, marginBottom: 16, alignItems: 'center' };
		if (fields && fields.length > 0) {
			btnDoms.push(
				<Button key="reset" style={_btnStyle} onClick={() => {
					form.resetFields();
					form.submit();
				}}><ReloadOutlined style={{ fontSize: 12 }} />重置</Button>
			);
			btnDoms.push(
				<Button key="submit" style={_btnStyle} type="primary" htmlType="submit"><SearchOutlined style={{ fontSize: 12 }} />搜索</Button>
			);
		}
		// if(props.exportHandle) {
		// 	btnDoms.push(<Button key="export" style={_btnStyle} type="primary" onClick={() => {
		// 		const values = form.getFieldsValue();
		// 		const data = valuesHandle(values);
		// 		typeof props.exportHandle == 'function' && props.exportHandle(data);
		// 	}}><ExportOutlined style={{ fontSize: 12 }} />导出</Button>)
		// }
		// if(props.newHandle) {
		// 	btnDoms.push(<Button key="new" style={_btnStyle} type="primary" onClick={() => {
		// 		props.newHandle && props.newHandle();
		// 	// }}><i className={`icon iconfont iconadd`} style={{ marginRight: 4, fontSize: 12 }} />新增</Button>)
		// 	}}><PlusOutlined style={{ fontSize: 12 }} />{props.newBtnText || '新增'}</Button>)
		// }
		// if(props.importAction) {
		// 	btnDoms.push(<div key="import" style={{display: 'inline-block'}}>
		// 		<div style={{display: 'flex', alignItems: 'center'}}>
		// 			<Upload {...{
		// 				name: 'file',
		// 				action: CONF.apiPrefix + props.importAction,
		// 				onChange: (info) => {
		// 					setImportLoading(true);
		// 					if (info.file.status !== 'uploading') {
		// 						console.log(info.file, info.fileList);
		//
		// 					}
		// 					if (info.file.status === 'done') {
		// 						if(info.file.response && info.file.response.ok == 0) {
		// 							message.success(`${info.file.name}导入成功，请刷新页面查看数据`);
		// 						}else{
		// 							message.error(`${info.file.name}导入失败-${info.file.response.msg}`);
		// 						}
		// 						setImportLoading(false);
		// 					} else if (info.file.status === 'error') {
		// 						message.error(`${info.file.name} file upload failed.`);
		// 					}
		// 				},
		// 			}}>
		// 				{
		// 					importLoading &&
		// 					<Button type="primary" icon={<LoadingOutlined />}>导入中……</Button> ||
		// 					<Button type="primary" icon={<PlusOutlined />}>数据导入</Button>
		// 				}
		// 			</Upload>
		// 			{ props.importTplLink && <a href={props.importTplLink} target="__blank" style={{marginLeft: 4, textDecoration: 'underline'}}>导入模版下载</a> }
		// 		</div>
		// 	</div>)
		// }
		// if(props.extra && props.extra.btnText) {
		// 	btnDoms.push(<Button key="extra" style={_btnStyle} type="primary" onClick={() => {
		// 		props.extra.actionHandle && props.extra.actionHandle();
		// 	}}><i className={`icon iconfont iconedit`} style={{ marginRight: 4, fontSize: 12 }} />{props.extra.btnText}</Button>)
		// }

		return btnDoms;
	})();

	const valuesHandle = (values) => {
		const data = {};
		Object.keys(values).map(k => {
			const nk = k.replace('s-', '');
			if (!!values[k] || values[k] === 0) {
				data[nk] = values[k];
			}
		});
		return data;
	};

	if (doms.length == 0 && btnDoms.length == 0) return null;

	return (
		<div className="filter-panel-component-container" style={props.style}>
			<Form {...{
				style: { marginBottom: -13, width: '100%' },
				// labelCol: { flex: '100px' },
				// wrapperCol: { flex: 'auto' },
				labelCol: { span: 8 },
				wrapperCol: { span: 16 },
				form,
				onFinish: values => {
					const data = valuesHandle(values);
					props.filterHandle && props.filterHandle(data);
				}
			}}>
				<Row>
					<Col span={18}>
						<Row>{doms}</Row>
					</Col>
					<Col span={6}>
						<div className="filter-panel-component-form-ctrl">{btnDoms}</div>
					</Col>
				</Row>
			</Form>
		</div>
	)
};

export default CompModel;
